/**
 * Utilidades de categorías: el path se muestra como slug compacto
 * (ej. `video/ahj-ende/ventas/v1/5-pasos-de-la-venta`) en vez de
 * breadcrumbs de pills — mismo formato en toda la app.
 */

export function slugifySegment(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // sin acentos
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Cadena de categorías → slug `raiz/rama/hoja`.
 *
 * Usa el slug GUARDADO de cada categoría (migración 074) y sólo cae al nombre
 * si no viene: así renombrar una categoría no mueve las URLs públicas.
 */
export function categorySlug(chain: { name: string; slug?: string | null }[]): string {
  return chain.map((c) => c.slug || slugifySegment(c.name)).join("/");
}
